<template>
  <BModal
    id="modal-notification-transaction"
    ref="modal-notification-transaction"
    centered
    hide-header
    hide-footer
    no-stacking
    body-class="p-0"
    dialog-class="modal-notification-transaction-dialog"
    content-class="modal-notification-transaction-content"
    @show="onModalShow"
    @hidden="onModalHidden"
  >
    <div class="modal-notif-trans-body">
      <!-- Close Button (X) -->
      <button
        type="button"
        class="modal-close-icon-btn"
        aria-label="Close"
        @click="handleCancel"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#828282"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <!-- Title -->
      <h3 class="modal-notif-trans-title">
        Notifikasi Transaksi
      </h3>

      <!-- Description -->
      <p class="modal-notif-trans-desc">
        <span class="desc-line">Aktifkan Notifikasi dan Auto Freeze Card untuk memberitahu dan mencegah jika</span>
        <span class="desc-line">ada Transaksi mencurigakan.</span>
      </p>

      <!-- Section Notifikasi -->
      <div class="modal-notif-trans-section">
        <label class="modal-notif-section-label">
          Notifikasi
        </label>
        <div class="modal-notif-checkbox-group">
          <!-- Checkbox Nominal -->
          <div class="checkbox-with-info">
            <label class="custom-checkbox-item">
              <input
                v-model="notificationTypes"
                type="checkbox"
                value="nominal"
                class="custom-checkbox-input"
              >
              <span
                class="custom-checkbox-indicator"
                :class="{ 'is-checked': notificationTypes.includes('nominal') }"
              >
                <svg
                  v-if="notificationTypes.includes('nominal')"
                  class="checkbox-check-icon"
                  width="10"
                  height="8"
                  viewBox="0 0 10 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4L3.5 6.5L9 1"
                    stroke="white"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="checkbox-text-label">Nominal</span>
            </label>
            <div
              id="tooltip-nominal"
              class="checkbox-info-trigger"
              tabindex="0"
              @click.stop.prevent
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="info-circle-icon"
              >
                <circle
                  cx="7"
                  cy="7"
                  r="6.25"
                  stroke="#2E90FA"
                  stroke-width="1.3"
                />
                <path
                  d="M7 6.2V10"
                  stroke="#2E90FA"
                  stroke-width="1.3"
                  stroke-linecap="round"
                />
                <circle
                  cx="7"
                  cy="4.3"
                  r="0.8"
                  fill="#2E90FA"
                />
              </svg>
            </div>
            <b-tooltip
              target="tooltip-nominal"
              triggers="hover focus"
              placement="top"
              custom-class="custom-komcard-tooltip"
            >
              <span class="tooltip-line">Transaksi dengan nominal di</span>
              <span class="tooltip-line">atas batas yang kamu input</span>
            </b-tooltip>
          </div>

          <!-- Checkbox Non-Ads Merchant -->
          <div class="checkbox-with-info">
            <label class="custom-checkbox-item">
              <input
                v-model="notificationTypes"
                type="checkbox"
                value="non_ads_merchant"
                class="custom-checkbox-input"
              >
              <span
                class="custom-checkbox-indicator"
                :class="{ 'is-checked': notificationTypes.includes('non_ads_merchant') }"
              >
                <svg
                  v-if="notificationTypes.includes('non_ads_merchant')"
                  class="checkbox-check-icon"
                  width="10"
                  height="8"
                  viewBox="0 0 10 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4L3.5 6.5L9 1"
                    stroke="white"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="checkbox-text-label">Non-Ads Merchant</span>
            </label>
            <div
              id="tooltip-merchant"
              class="checkbox-info-trigger"
              tabindex="0"
              @click.stop.prevent
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="info-circle-icon"
              >
                <circle
                  cx="7"
                  cy="7"
                  r="6.25"
                  stroke="#2E90FA"
                  stroke-width="1.3"
                />
                <path
                  d="M7 6.2V10"
                  stroke="#2E90FA"
                  stroke-width="1.3"
                  stroke-linecap="round"
                />
                <circle
                  cx="7"
                  cy="4.3"
                  r="0.8"
                  fill="#2E90FA"
                />
              </svg>
            </div>
            <b-tooltip
              target="tooltip-merchant"
              triggers="hover focus"
              placement="top"
              custom-class="custom-komcard-tooltip"
            >
              <span class="tooltip-line">Transaksi ke merchant selain</span>
              <span class="tooltip-line">merchant Iklan</span>
            </b-tooltip>
          </div>
        </div>

        <span
          v-if="!notificationTypes || notificationTypes.length === 0"
          class="options-error-text"
        >
          Minimal salah satu opsi Non-ads merchant atau Nominal harus terpilih
        </span>

        <!-- Input Nominal with Smooth Transition Animation -->
        <transition name="nominal-input-anim">
          <div
            v-if="notificationTypes.includes('nominal')"
            class="nominal-input-wrapper"
          >
            <input
              v-model="nominalAmount"
              type="text"
              placeholder="input nominal"
              class="nominal-text-input"
              :class="{ 'has-error': isNominalInvalid }"
              @input="onNominalInput"
            >
            <span
              v-if="isNominalInvalid"
              class="nominal-error-text"
            >
              Nominal harus lebih besar dari 0
            </span>
          </div>
        </transition>
      </div>

      <!-- Section Auto Freeze -->
      <div class="modal-auto-freeze-row">
        <span class="auto-freeze-label">Auto Freeze</span>
        <div
          id="tooltip-auto-freeze"
          class="auto-freeze-info-trigger"
          tabindex="0"
          @click.stop.prevent
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="info-circle-icon"
          >
            <circle
              cx="7"
              cy="7"
              r="6.25"
              stroke="#2E90FA"
              stroke-width="1.3"
            />
            <path
              d="M7 6.2V10"
              stroke="#2E90FA"
              stroke-width="1.3"
              stroke-linecap="round"
            />
            <circle
              cx="7"
              cy="4.3"
              r="0.8"
              fill="#2E90FA"
            />
          </svg>
        </div>
        <b-tooltip
          target="tooltip-auto-freeze"
          triggers="hover focus"
          placement="top"
          custom-class="custom-komcard-tooltip"
        >
          <span class="tooltip-line">Kartu otomatis dibekukan saat</span>
          <span class="tooltip-line">memenuhi kriteria notifikasi</span>
          <span class="tooltip-line">yang kamu pilih.</span>
        </b-tooltip>

        <label class="custom-toggle-switch">
          <input
            v-model="autoFreeze"
            type="checkbox"
            class="custom-toggle-input"
          >
          <span class="custom-toggle-track">
            <span class="custom-toggle-thumb" />
          </span>
        </label>
      </div>

      <!-- Footer Buttons -->
      <div class="modal-notif-actions">
        <button
          type="button"
          class="btn-modal-cancel"
          @click="handleCancel"
        >
          Batal
        </button>
        <button
          type="button"
          class="btn-modal-confirm"
          :disabled="isConfirmDisabled"
          @click="handleConfirm"
        >
          <BSpinner
            v-if="loading"
            small
            class="mr-1"
          />
          Konfirmasi
        </button>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalNotificationTransaction',
  props: {
    initialNotificationTypes: {
      type: Array,
      default: () => ['non_ads_merchant'],
    },
    initialNominal: {
      type: [String, Number],
      default: '',
    },
    initialAutoFreeze: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notificationTypes: (this.initialNotificationTypes && Array.isArray(this.initialNotificationTypes) && this.initialNotificationTypes.length > 0)
        ? [...this.initialNotificationTypes]
        : ['non_ads_merchant'],
      nominalAmount: this.initialNominal || '',
      autoFreeze: !!this.initialAutoFreeze,
    }
  },
  computed: {
    isNominalInvalid() {
      if (!this.notificationTypes || !this.notificationTypes.includes('nominal')) {
        return false
      }
      const val = String(this.nominalAmount || '').trim()
      if (!val) {
        // AC-11: Empty field is just disabled, not invalid error
        return false
      }
      if (val === '0' || val.startsWith('-')) {
        return true
      }
      const num = Number(val.replace(/\./g, '').replace(/,/g, ''))
      if (Number.isNaN(num) || num <= 0) {
        return true
      }
      return false
    },
    isConfirmDisabled() {
      if (this.loading) {
        return true
      }
      if (!this.notificationTypes || this.notificationTypes.length === 0) {
        return true
      }
      if (this.notificationTypes.includes('nominal')) {
        const clean = String(this.nominalAmount || '').trim()
        if (!clean) {
          return true
        }
        if (this.isNominalInvalid) {
          return true
        }
      }
      return false
    },
  },
  watch: {
    initialNotificationTypes: {
      immediate: true,
      handler(val) {
        if (val && Array.isArray(val) && val.length > 0) {
          this.notificationTypes = [...val]
        } else {
          this.notificationTypes = ['non_ads_merchant']
        }
      },
    },
    initialNominal: {
      immediate: true,
      handler(val) {
        if (val !== undefined && val !== null && val !== '') {
          const num = Number(String(val).replace(/\D/g, ''))
          if (num > 0) {
            this.nominalAmount = new Intl.NumberFormat('id-ID').format(num)
          } else {
            this.nominalAmount = ''
          }
        } else {
          this.nominalAmount = ''
        }
      },
    },
    initialAutoFreeze: {
      immediate: true,
      handler(val) {
        this.autoFreeze = !!val
      },
    },
  },
  methods: {
    resetToInitial() {
      this.notificationTypes = (this.initialNotificationTypes && Array.isArray(this.initialNotificationTypes) && this.initialNotificationTypes.length > 0)
        ? [...this.initialNotificationTypes]
        : ['non_ads_merchant']
      if (this.initialNominal !== undefined && this.initialNominal !== null && this.initialNominal !== '') {
        const num = Number(String(this.initialNominal).replace(/\D/g, ''))
        this.nominalAmount = num > 0 ? new Intl.NumberFormat('id-ID').format(num) : ''
      } else {
        this.nominalAmount = ''
      }
      this.autoFreeze = !!this.initialAutoFreeze
    },
    onModalShow() {
      this.resetToInitial()
    },
    onModalHidden() {
      this.resetToInitial()
    },
    handleCheckboxToggle(type) {
      const index = this.notificationTypes.indexOf(type)
      if (index > -1) {
        this.notificationTypes.splice(index, 1)
      } else {
        this.notificationTypes.push(type)
      }
    },
    onNominalInput(event) {
      const rawValue = event.target.value
      const trimmed = rawValue.trim()

      if (!trimmed) {
        this.nominalAmount = ''
        return
      }

      // If user inputs negative sign or negative numbers
      if (trimmed.startsWith('-')) {
        const afterMinus = trimmed.slice(1).replace(/\D/g, '')
        if (afterMinus) {
          const num = Number(afterMinus)
          this.nominalAmount = `-${new Intl.NumberFormat('id-ID').format(num)}`
        } else {
          this.nominalAmount = '-'
        }
        return
      }

      // If only zeros entered: '0', '00', etc.
      if (/^0+$/.test(trimmed)) {
        this.nominalAmount = '0'
        return
      }

      // If numeric digits entered
      const onlyDigits = trimmed.replace(/\D/g, '')
      if (onlyDigits && /^[0-9., ]+$/.test(trimmed)) {
        const num = Number(onlyDigits)
        this.nominalAmount = new Intl.NumberFormat('id-ID').format(num)
        return
      }

      // If non-numeric characters entered
      this.nominalAmount = rawValue
    },
    handleCancel() {
      this.resetToInitial()
      this.$bvModal.hide('modal-notification-transaction')
      this.$emit('cancel')
    },
    handleConfirm() {
      if (this.isConfirmDisabled || !this.notificationTypes || this.notificationTypes.length === 0) {
        return
      }
      const hasNominal = this.notificationTypes && this.notificationTypes.includes('nominal')
      const hasNonAds = this.notificationTypes && this.notificationTypes.includes('non_ads_merchant')
      const hasAnyNotif = hasNominal || hasNonAds

      this.$emit('confirm', {
        notification_types: this.notificationTypes,
        nominal: this.nominalAmount,
        auto_freeze: hasAnyNotif ? this.autoFreeze : false,
        notif_by_nominal: hasNominal,
        notif_by_nominal_amount: hasNominal
          ? Number(String(this.nominalAmount || '0').replace(/\D/g, ''))
          : 0,
        notif_by_non_ads_merchant: hasNonAds,
        trigger_auto_freeze: hasAnyNotif ? this.autoFreeze : false,
      })
    },
  },
}
</script>

<style lang="scss">
.modal-notification-transaction-dialog {
  width: 500px !important;
  max-width: 500px !important;
  margin: 1.75rem auto !important;

  @media (max-width: 575.98px) {
    width: calc(100% - 32px) !important;
    max-width: 100% !important;
  }

  .modal-notification-transaction-content {
    border: none !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
    padding: 0 !important;
    overflow: hidden !important;
    background-color: #ffffff !important;
  }

  .modal-body {
    padding: 0 !important;
  }
}

.modal-notif-trans-body {
  position: relative;
  padding: 22px 18px 18px 18px;
  box-sizing: border-box;
}

.modal-close-icon-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: none;
  border-radius: 50%;
  transition: background-color 0.18s ease;

  &:hover {
    background-color: #f5f5f5;
  }
}

.modal-notif-trans-title {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  text-align: center;
  margin: 0 0 16px 0;
  line-height: 1.25;
}

.modal-notif-trans-desc {
  font-family: 'Poppins', sans-serif;
  font-size: 11.5px;
  font-weight: 400;
  color: #000000;
  line-height: 1.5;
  margin: 0 0 22px 0;
  text-align: left;

  .desc-line {
    display: block;
    white-space: nowrap;

    @media (max-width: 500px) {
      white-space: normal;
    }
  }
}

.modal-notif-trans-section {
  margin-bottom: 18px;
}

.modal-notif-section-label {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #000000;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.modal-notif-checkbox-group {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 24px;
}

.checkbox-with-info {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  .checkbox-info-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;
    cursor: pointer;
    outline: none;

    .info-circle-icon {
      width: 12px;
      height: 12px;
      display: block;
    }
  }
}

/* Custom Checkbox */
.custom-checkbox-item {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;

  .custom-checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    z-index: -1;
  }

  .custom-checkbox-indicator {
    width: 16px;
    height: 16px;
    border-radius: 5px;
    border: 1.5px solid #e2e2e2;
    background-color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    transition: all 0.18s ease;
    box-sizing: border-box;
    flex-shrink: 0;

    &.is-checked {
      background-color: #f95031;
      border-color: #f95031;
    }
  }

  .custom-checkbox-input:checked + .custom-checkbox-indicator {
    background-color: #f95031;
    border-color: #f95031;
  }

  .checkbox-text-label {
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    color: #222222;
    font-weight: 400;
  }
}

/* Input Nominal & Native CSS Smooth Animation */
.nominal-input-wrapper {
  margin-top: 12px;
}

.nominal-text-input {
  width: 100%;
  height: 34px;
  background-color: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 0 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #222222;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: #b0b0b0;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 400;
  }

  &:focus {
    border-color: #f95031;
    box-shadow: 0 0 0 2px rgba(249, 80, 49, 0.12);
  }

  &.has-error {
    border-color: #f04438 !important;

    &:focus {
      border-color: #f04438 !important;
      box-shadow: 0 0 0 2px rgba(240, 68, 56, 0.15) !important;
    }
  }
}

.nominal-error-text {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #f04438;
  margin-top: 5px;
  line-height: 1.2;
}

.options-error-text {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #f04438;
  margin-top: 8px;
  line-height: 1.3;
}

.nominal-input-anim-enter-active {
  transition: all 0.28s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  max-height: 80px;
}

.nominal-input-anim-leave-active {
  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  max-height: 80px;
}

.nominal-input-anim-enter,
.nominal-input-anim-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-4px);
  margin-top: 0 !important;
}

/* Auto Freeze Row */
.modal-auto-freeze-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-bottom: 22px;

  .auto-freeze-label {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #000000;
    margin: 0 8px 0 0;
    line-height: 1.2;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .auto-freeze-info-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 12px;
    flex-shrink: 0;
    outline: none;

    .info-circle-icon {
      width: 12px;
      height: 12px;
      display: block;
    }
  }

  .custom-toggle-switch {
    margin: 0;
    flex-shrink: 0;
  }
}

/* Custom Toggle Switch */
.custom-toggle-switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 20px;
  margin: 0;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;

  .custom-toggle-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .custom-toggle-track {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f4f4f4;
    border: 1px solid #e9e9e9;
    border-radius: 9999px;
    box-sizing: border-box;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .custom-toggle-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #e2e2e2;
    transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), background-color 0.2s ease;
  }

  .custom-toggle-input:checked + .custom-toggle-track {
    background-color: #f95031;
    border-color: #f95031;
  }

  .custom-toggle-input:checked + .custom-toggle-track .custom-toggle-thumb {
    transform: translateX(18px);
    background-color: #ffffff;
  }
}

/* Footer Buttons */
.modal-notif-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  .btn-modal-cancel {
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border: 1px solid #f95031;
    border-radius: 6px;
    color: #f95031;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    outline: none;
    transition: all 0.18s ease;

    &:hover {
      background-color: #fff6f4;
    }

    &:active {
      background-color: #ffe8d9;
    }
  }

  .btn-modal-confirm {
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #f95031;
    border: 1px solid #f95031;
    border-radius: 6px;
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    outline: none;
    transition: all 0.18s ease;

    &:hover:not(:disabled) {
      background-color: #e04426;
      border-color: #e04426;
    }

    &:active:not(:disabled) {
      background-color: #c93a1e;
      border-color: #c93a1e;
    }

    &:disabled {
      background-color: #c4c4c4 !important;
      border-color: #c4c4c4 !important;
      color: #ffffff !important;
      opacity: 1 !important;
      cursor: not-allowed !important;
    }
  }
}

/* Custom Tooltip Styling */
.tooltip.custom-komcard-tooltip {
  z-index: 1060 !important;

  &.show {
    opacity: 1 !important;
  }

  .tooltip-inner {
    max-width: 320px !important;
    background-color: #ffffff !important;
    color: #222222 !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 1.45 !important;
    text-align: left !important;
    padding: 10px 14px !important;
    border-radius: 8px !important;
    border: none !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.14) !important;
    white-space: normal !important;

    .tooltip-line {
      display: block;
      white-space: nowrap;
      color: #222222;
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.45;
    }
  }

  &.bs-tooltip-top,
  &.bs-tooltip-auto[x-placement^="top"] {
    padding-bottom: 9px !important;
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;

    .arrow {
      bottom: 0 !important;
      width: 16px !important;
      height: 9px !important;

      &::before {
        top: -1px !important;
        left: 0 !important;
        border-color: #f95031 transparent transparent transparent !important;
        border-style: solid !important;
        border-width: 10px 8px 0 8px !important;
        border-top-color: #f95031 !important;
      }
    }
  }

  &.bs-tooltip-bottom,
  &.bs-tooltip-auto[x-placement^="bottom"] {
    padding-top: 9px !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;

    .arrow {
      top: 0 !important;
      width: 16px !important;
      height: 9px !important;

      &::before {
        bottom: -1px !important;
        left: 0 !important;
        border-color: transparent transparent #f95031 transparent !important;
        border-style: solid !important;
        border-width: 0 8px 10px 8px !important;
        border-bottom-color: #f95031 !important;
      }
    }
  }
}
</style>
